module.exports = __webpack_public_path__ + "static/media/dark-rtl.b32a80c5.png";